import { HEADER_STYLES } from "../../../enums/HeaderStyles";

const dropDownColumns = ["U_name", "U_status", "U_project", "U_businessTrip", "U_employeeId", "U_weekday"];

const rangeColumns = [
  "U_ratio",
  "U_coming",
  "U_leaving",
  "U_workTime",
  "U_breakTime",
  "U_projectTime",
  "U_totalTime",
  "U_difference",
  "U_requiredTime",
  "U_date",
  "U_time",
  "calendarWeek",
  "U_debit",
  "U_sumIs",
  "U_sumWas"
];
const searchColumns = ["teams"];

export default [
  ...rangeColumns.map((column) => ({
    column,
    value: HEADER_STYLES.RANGE
  })),
  ...dropDownColumns.map((column) => ({
    column,
    value: HEADER_STYLES.DROPDOWN
  })),
  ...searchColumns.map((column) => ({
    column,
    value: HEADER_STYLES.SEARCH
  }))
];
